/* SECTORS hardcoded values */
/* WARNING: Replace the hardcoded ID test values them */
export const getSectorValues = (intl) => [
  {
    id: "TWFya2V0Tm9kZToy",
    value: "TWFya2V0Tm9kZToy",
    label: intl.formatMessage({
      id: "ProjectStepForm.sectors.contract",
      defaultMessage: "Contract",
    }),
  },
  {
    id: "TWFya2V0Tm9kZTo0",
    value: "TWFya2V0Tm9kZTo0",
    label: intl.formatMessage({
      id: "ProjectStepForm.sectors.marine",
      defaultMessage: "Marine",
    }),
  },
  {
    id: "TWFya2V0Tm9kZTo2",
    value: "TWFya2V0Tm9kZTo2",
    label: intl.formatMessage({
      id: "ProjectStepForm.sectors.footwear",
      defaultMessage: "Footwear",
    }),
  },
  {
    id: "TWFya2V0Tm9kZTo1",
    value: "TWFya2V0Tm9kZTo1",
    label: intl.formatMessage({
      id: "ProjectStepForm.sectors.protection",
      defaultMessage: "Protection",
    }),
  },
  {
    id: "TWFya2V0Tm9kZTox",
    value: "TWFya2V0Tm9kZTox",
    label: intl.formatMessage({
      id: "ProjectStepForm.sectors.transportation",
      defaultMessage: "Transportation",
    }),
  },
];
